module.exports = __webpack_public_path__ + "img/36.ba88457c.svg";